import { useQuery } from '@tanstack/react-query';
import { isNil } from 'lodash';
import clientApi from '~/clientApi';
import { LOCATION_SEARCH } from '~/queries/keys';

export const useLocationSearch = (value: string | null) => {
  return useQuery(
    [LOCATION_SEARCH, value],
    () => {
      if (!value) return;
      return clientApi.locations.search({ search: value });
    },
    { enabled: !isNil(value) && value?.length > 2 },
  );
};
